













































































































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class SideBar extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop() addExpenseAction: () => void;
  @Prop() displayPersonalExpenseTracker: boolean;
  @Prop() hideHowItWorks: boolean;

  fullView = true;

  onClick (): void {
    this.fullView = !this.fullView;
  }
}
